import { useAppointmentQuery } from "../../../../../../api/appointments/useAppointmentQuery";
import { uiNotification } from "../../../../../../services/UINotificationService";

export function useAppointment(id, onError, onSuccess) {
  const { data, isLoading, refetch, isFetching } = useAppointmentQuery({
    payload: {
      appointmentId: id,
    },
    options: {
      onError: () => {
        uiNotification.error(
          "Unable to load appointment details. Try again later.",
        );
        onError();
      },
      onSuccess,
    },
  });

  return {
    appointment: data,
    isAppointmentLoading: isLoading,
    refetchAppointment: refetch,
    isAppointmentFetching: isFetching,
  };
}
